import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import '../../styles/UserSettings.scss';

import AmbryIDs from './containers/AmbryIDs';
import Licensing from './containers/Licensing';
import Formats from './containers/Formats';
import Security from './containers/Security';
import { I18n } from 'react-redux-i18n';

const TabsType = PropTypes.shape({
    security: PropTypes.bool,
    licensing: PropTypes.bool,
    formats: PropTypes.bool,
    ambryIDs: PropTypes.bool,
});

const TabMethodsType = PropTypes.shape({
    onChange: PropTypes.func.isRequired,
}).isRequired;

class Settings extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        tabsToDisable: TabsType,
        tabsToShow: TabsType,
        methods: PropTypes.shape({
            security: TabMethodsType,
            licensing: TabMethodsType,
            formats: TabMethodsType,
        }).isRequired
    };

    static defaultProps = {
        tabsToDisable: {
            security: false,
            licensing: false,
            formats: false,
            ambryIDs: false,
        },
        tabsToShow: {
            security: true,
            licensing: true,
            formats: true,
            ambryIDs: true,
        }
    };

    state = {
        currentTabId: undefined,
    };

    constructor(props) {
        super(props);

        this.state = {
            currentTabId: (this.getActiveTab()).id
        };
    }

    get tabs() {
        const { data, tabsToDisable, tabsToShow, methods } = this.props;

        return [
            {
                label: 'Security',
                component: (
                    <Security
                        isAdmin={data.admin}
                        name={data.username || data.name}
                        classes={data.classes}
                        className={tabsToDisable.security ? 'User-details-settings__content-disabled' : ''}
                        onChange={methods.security.onChange}
                    />
                ),
                id: 'security'
            },
            {
                label: 'Licensing',
                component: (
                    <Licensing
                        isAdmin={data.admin}
                        licensing={data.licensing}
                        name={data.username || data.name}
                        useClassBased={data.useClassBased}
                        classes={data.classes}
                        className={tabsToDisable.licensing ? 'User-details-settings__content-disabled' : ''}
                        onChange={methods.licensing.onChange}
                    />
                ),
                id: 'licensing'
            },
            {
                label: 'Formats',
                component: (
                    <Formats
                        name={data.username || data.name}
                        data={data.defaultFormats}
                        className={tabsToDisable.formats ? 'User-details-settings__content-disabled' : ''}
                        onChange={methods.formats.onChange}
                    />
                ),
                id: 'formats'
            },
            {
                label: 'Ambry IDs',
                component: (
                    <AmbryIDs
                        name={data.username || data.name}
                        ambryIDs={data.ambryIDs}
                        className={tabsToDisable.ambryIDs ? 'User-details-settings__content-disabled' : ''}
                    />
                ),
                id: 'ambryIDs'
            },
        ].filter((tab) => tabsToShow[tab.id]);
    }

    get isCurrentTabDisabled() {
        const { tabsToDisable } = this.props;
        const { currentTabId } = this.state;

        return tabsToDisable[currentTabId];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.username !== this.props.data.username) {
            this.setActiveTab();
        }
    }

    getActiveTab = () => {
        const { currentTabId } = this.state;

        if (this.isCurrentTabDisabled || currentTabId === undefined) {
            return this.tabs.find((tab) => !this.props.tabsToDisable[tab.id]);
        }

        return this.tabs.find(({ id }) => id === this.state.currentTabId);
    };

    setActiveTab = () => {
        if (!this.isCurrentTabDisabled) {
            return;
        }

        this.setState((state) => ({ ...state, currentTabId: (this.getActiveTab()).id }));
    }

    onChangeTab = (e) => {
        e.persist();

        const { tabid } = e.currentTarget.dataset;
        const { tabsToDisable } = this.props;

        if (!tabsToDisable[tabid]) {
            this.setState((state) => ({ ...state, currentTabId: tabid }));
        }

    }

    render() {
        const { currentTabId } = this.state;
        const { tabsToDisable } = this.props;
        const TabComponent = (this.getActiveTab() || {}).component;

        return (
            <div className="User-details-settings">
                <div className="User-details-settings__tabs">
                    {this.tabs.map(({ label, id }) => (
                        <span
                            key={id}
                            data-tabid={id}
                            className={cx(
                                'User-details-settings__tabs__tab',
                                { 'User-details-settings__tabs__tab-active': currentTabId === id },
                                { 'User-details-settings__tabs__tab-disabled': tabsToDisable[id] },
                            )}
                            onClick={this.onChangeTab}
                        >
                            {I18n.t(label)}
                        </span>
                    ))}
                </div>
                <div className="User-details-settings__content">
                    {TabComponent}
                </div>
            </div>
        );
    }
}

export default Settings;